export function normalizeMarkdown(input) {
        const match = input.match(/^```markdown\n([\s\S]*)\n```$/);
        if (match) {
            return match[1]; // strip fences, parse as markdown
        }
        return input;
    }